/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProtectedGroup } from './ProtectedGroup';
import { ProtectedGroupFromJSON, ProtectedGroupFromJSONTyped, ProtectedGroupToJSON } from './ProtectedGroup';

/**
 *
 * @export
 * @interface ProtectedGroupDataset
 */
export interface ProtectedGroupDataset {
  /**
   *
   * @type {number}
   * @memberof ProtectedGroupDataset
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof ProtectedGroupDataset
   */
  datasetPath: string;
  /**
   *
   * @type {Array<ProtectedGroup>}
   * @memberof ProtectedGroupDataset
   */
  readonly protectedGroups: Array<ProtectedGroup>;
}

/**
 * Check if a given object implements the ProtectedGroupDataset interface.
 */
export function instanceOfProtectedGroupDataset(value: object): value is ProtectedGroupDataset {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('datasetPath' in value) || value['datasetPath'] === undefined) return false;
  if (!('protectedGroups' in value) || value['protectedGroups'] === undefined) return false;
  return true;
}

export function ProtectedGroupDatasetFromJSON(json: any): ProtectedGroupDataset {
  return ProtectedGroupDatasetFromJSONTyped(json, false);
}

export function ProtectedGroupDatasetFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProtectedGroupDataset {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    datasetPath: json['dataset_path'],
    protectedGroups: (json['protected_groups'] as Array<any>).map(ProtectedGroupFromJSON),
  };
}

export function ProtectedGroupDatasetToJSON(value?: Omit<ProtectedGroupDataset, 'id' | 'protectedGroups'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    dataset_path: value['datasetPath'],
  };
}
